import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cart";
import authReducer from "./auth";
import inventoryReducer from "./inventory";
import serviceReducer from "./services";
import statisticsReducer from "./statistics";
import appointmentReducer from "./appointment";
import purchaseorderReducer from "./purchaseorder"
import layoutReducer from "./layout"
import settingReducer from "./settings"
import clientReducer from "./client"
import dashboardReducer from "./dashboard"

const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    inventory: inventoryReducer,
    service: serviceReducer,
    statistic: statisticsReducer,
    appointment: appointmentReducer,
    purchaseorder: purchaseorderReducer,
    layout: layoutReducer,
    setting: settingReducer,
    client: clientReducer,
    dashboard: dashboardReducer,
  },
});

export default store;
